/***************************
处理URL相关的一些常规方法
***************************/

/**
 * Usage: 返回当前 URL。
 * “使用window.location.href获取当前 URL。”
 * @return 布尔值
 * Example:currentUrl() -> 'https://google.com'
 */
export const currentURL = () => window.location.href

/**
 * Usage: 返回一个包含当前 URL 参数的对象。
 * “使用match()与适当的正则表达式来获取所有键值对, Array.reduce()可将它们映射并合并到单个对象中。将location.search作为要应用于当前url的参数传递.”
 * Example: getURLParameters('http://url.com/page?name=Adam&surname=Smith') -> {name: 'Adam', surname: 'Smith'}
 */
export const getURLParameters = (url = currentURL()) => {
  const params = url.match(/([^?=&]+)(=([^(&|#|/)]*))/g)
  if (params === null) {
    return {}
  } else {
    return params.reduce(
      (a, v) => {
        a[v.slice(0, v.indexOf('='))] = v.slice(v.indexOf('=') + 1)
        return a
      }, {}
    )
  }
}

/**
 * Usage: 返回一个包含当前 URL 参数的对象。
 * “使用window.location.href或window.location.replace()重定向到url。传递第二个参数以模拟链接单击 (true -默认值) 或 HTTP 重定向 (false).”
 * Example:redirect('https://google.com')
 */
export const redirect = (url, asLink = true) => asLink ? (window.location.href = url) : (window.location.replace(url))

/**
 * Usage:  将一个对象转换为url的get参数
 */
export const objParseQuery = obj => {
  if (typeof obj !== 'object') return ''
  let arr = []
  for (let key in obj) {
    arr.push(key + '=' + encodeURIComponent(obj[key]))
  }
  return arr.join('&')
}

/**
 * 获取表单结构数据中指定参数的值
 */
export function getQueryString(str, name) {
  const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
  const r = str.match(reg)
  if (r != null) return decodeURIComponent(r[2])
  return ''
}
/**
 * 获取url地址中的参数
 * @param url 
 * @returns 
 */
export function getParamObjFromUrl(url = location.href) {
  const arrList = url.split("#");

  let paramData = {};

  arrList.forEach((strItem) => {
    let str = strItem; // 取得整个地址栏
    const num = str.indexOf("?");
    str = str.substr(num + 1); // 取得所有参数   stringvar.substr(start [, length ]
    if (num > -1) {
      const arr = str.split("&"); // 各个参数放到数组里
      for (let i = 0; i < arr.length; i += 1) {
        const n = arr[i].indexOf("=");
        if (n > 0) {
          // "&key=value" 键值对
          const key = arr[i].substring(0, n);
          const value = arr[i].substr(n + 1);
          paramData[key] = decodeURIComponent(value);
        } else {
          // "&key" 仅标识
          const key = arr[i];
          if (key !== "") paramData[key] = "";
        }
      }
    }
  });

  return paramData;
}